module.exports = __webpack_public_path__ + "img/blank.33354375.svg";